import { render } from "./exam_precise.vue?vue&type=template&id=23ee3a4b&scoped=true"
import script from "./exam_precise.vue?vue&type=script&lang=js"
export * from "./exam_precise.vue?vue&type=script&lang=js"

import "./exam_precise.vue?vue&type=style&index=0&id=23ee3a4b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ee3a4b"]])

export default __exports__